import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  ModalBody,
  Form,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { SuperAdminAction } from "../../Actions";
import { groupBy } from "lodash";
import { v4 as uuidv4 } from "uuid";
import isEqual from "lodash/isEqual";
import { saveAs } from "file-saver";

class UserTypes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headersData: [],
      userTypesData: [],
      showModal: false,
      newUserType: "",
      error: "",
      edit: false,
      rowAdded: false,
      dynamicHeader: [],
      loader: false,
      subError: "",
      duplicates: [],
    };
  }

  componentDidMount = async () => {
    await this.props.get_all_user_types();
    if (this.props.allUserTypes && this.props.allUserTypes.length) {
      this.getUserList(this.props.allUserTypes);
    }
  };

  componentDidUpdate = async (prevProps) => {
    if (!isEqual(prevProps.allUserTypes, this.props.allUserTypes)) {
      this.getUserList(this.props.allUserTypes);
    }
  };

  getUserList = async (allUserTypes) => {
    const dynamicHeader = [];
    const superData = allUserTypes.filter((da) => da.permission_id === 1);
    Object.keys(superData[0]).forEach((dt) => {
      if (
        dt !== "permission_id" &&
        dt !== "user_type" &&
        dt !== "user_sub_type" &&
        dt !== "editable" &&
        dt !== "editable_sub"
      ) {
        dynamicHeader.push(dt);
      }
    });

    const userArray = allUserTypes.map((user) => {
      user.editable = false;
      user.editable_sub = false;
      return user;
    });
    const doc = await groupBy(userArray, "user_type");

    // eslint-disable-next-line
    let headers = [doc.superadmin].sort(function (a, b) {
      return dynamicHeader.indexOf(a.type) - dynamicHeader.indexOf(b.type);
    });
    headers = headers[0];
    const datas = Object.keys(headers[0])
      .map((header) => {
        if (dynamicHeader.includes(header)) {
          return {
            [header]:
              header.replace(/_/g, " ").charAt(0).toUpperCase() +
              header.slice(1).replace(/_/g, " "),
          };
        }
        return undefined;
      })
      .filter((he) => he !== undefined);
    this.setState({
      headersData: datas,
      userTypesData: doc,
      dynamicHeader: dynamicHeader,
    });
  };

  handleUserTypeName = () => {
    let { userTypesData, index, newUserType } = this.state;
    if (newUserType.length) {
      Object.keys(userTypesData).forEach((data, i) => {
        if (i === index) {
          const oldData = userTypesData[data];
          oldData[0].user_type = newUserType;
          delete userTypesData[data];
          userTypesData = Object.assign(
            { [newUserType]: oldData },
            userTypesData
          );
        }
      });
      this.setState({ userTypesData, showModal: false });
    } else {
      this.setState({ error: "Please add User Type" });
    }
  };

  handleFieldsChange = (e, id, type) => {
    const { userTypesData } = this.state;
    if (e.target.type === "checkbox") {
      let value = 0;
      if (e.target.checked) {
        value = 1;
      }
      Object.keys(userTypesData).forEach((data) => {
        if (userTypesData[data].length) {
          userTypesData[data].forEach((item) => {
            if (item.permission_id === id) {
              item[type] = value;
            }
          });
        }
      });
    } else {
      const value = e.target.value;
      Object.keys(userTypesData).forEach((data) => {
        if (userTypesData[data].length) {
          userTypesData[data].forEach((item) => {
            if (item.permission_id === id) {
              item.user_sub_type = value;
              item.editedSubType = true;
            }
          });
        }
      });
    }
    if (this.state.duplicates[0] === type) {
      this.setState({ subError: "" });
    }
    this.setState({ userTypesData });
  };

  handleSubmit = async () => {
    this.setState({ loader: true });
    const { userTypesData } = this.state;
    const updatedData = Object.keys(userTypesData)
      .map((item) => {
        return [].concat(userTypesData[item]);
      })
      .flat();

    const duplicateData = [];
    Object.keys(userTypesData).forEach((data) => {
      userTypesData[data].forEach((item) => {
        if (item.error) {
          item.error = "";
        }
      });
      const arr = [];
      const subTypeData = userTypesData[data];
      if (userTypesData[data][0].user_sub_type) {
        subTypeData.forEach((item) => {
          arr.push(item.user_sub_type);
        });
        let duplicates = [...arr];
        const yourArrayWithoutDuplicates = [...new Set(arr)];
        yourArrayWithoutDuplicates.forEach((item) => {
          const i = duplicates.indexOf(item);
          duplicates = duplicates
            .slice(0, i)
            .concat(duplicates.slice(i + 1, duplicates.length));
        });
        duplicates.forEach((data2) => {
          userTypesData[data].forEach((item) => {
            if (item.user_sub_type === data2) {
              item.error = "Please use another sub type";
            }
          });
        });
        duplicateData.push(...duplicates);
      }
    });

    if (duplicateData[0] !== undefined) {
      this.setState({
        loader: false,
        rowAdded: false,
        userTypesData: userTypesData,
      });
    } else {
      const res = await this.props.update_user_types(updatedData);
      if (res) {
        this.setState({
          loader: false,
          rowAdded: false,
          userTypesData: userTypesData,
        });
      }
    }
  };

  addUserSubtype = (user_type) => {
    const { userTypesData } = this.state;
    const newRow = {
      manage_units: 1,
      current_visitors: 1,
      view_all_permits: 1,
      add_visitor: 1,
      photo_verify: 1,
      lpr_report: 1,
      parking_log: 1,
      citations: 1,
      report: 1,
      user_sub_type: "sub type",
      user_type: user_type,
      editable_sub: true,
      editable: false,
      permission_id: uuidv4(),
    };
    userTypesData[user_type].push(newRow);
    this.setState({ userTypesData });
  };

  addUserType = () => {
    let { userTypesData, newUserType, showModal } = this.state;
    const typeInLowerCase = newUserType.toLowerCase();
    if (newUserType.length) {
      if (typeInLowerCase in userTypesData) {
        this.setState({ error: "User Type already exists" });
      } else {
        const newRow = [
          {
            manage_units: 1,
            current_visitors: 1,
            view_all_permits: 1,
            add_visitor: 1,
            photo_verify: 1,
            lpr_report: 1,
            parking_log: 1,
            citations: 1,
            report: 1,
            user_sub_type: "",
            user_type: typeInLowerCase,
            editable: true,
            permission_id: uuidv4(),
            editable_sub: false,
          },
        ];
        userTypesData = Object.assign(
          { [typeInLowerCase]: newRow },
          userTypesData
        );
        this.setState({ userTypesData, showModal: !showModal, rowAdded: true });
      }
    } else {
      this.setState({ error: "Please add User Type" });
    }
  };

  showUsersTypeTable = (userTypesData) => {
    const table = Object.keys(userTypesData).map((item, i) => {
      if (userTypesData[item].length) {
        return userTypesData[item].map((data, index) => {
          return (
            <Row
              key={index}
              className="margin-table usertype-table-body user-table-row"
            >
              <OverlayTrigger
                delay={{ show: 250, hide: 400 }}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-qw`}>
                    {!data.editable && <>{data.user_type}</>}
                  </Tooltip>
                }
              >
                <Col className="fs-14px fw-500 usertype-left-column">
                  {" "}
                  {data?.editable && (
                    <>
                      {data.user_type}
                      <i
                        title="Edit User Sub Type"
                        className="fa fa-pen cursor-pointer"
                        onClick={() => this.showUserTypeModal("edit", i)}
                      ></i>
                    </>
                  )}
                  {!data.editable && <>{data.user_type}</>}
                </Col>
              </OverlayTrigger>
              <Col>
                <div className="d-flex flex-column align-items-center">
                  {data.user_sub_type !== null && (
                    <>
                      <input
                        autoFocus={false}
                        type="text"
                        value={data.user_sub_type}
                        className="form-control user-type-input"
                        onChange={(e) =>
                          this.handleFieldsChange(
                            e,
                            data.permission_id,
                            data.user_sub_type
                          )
                        }
                      />
                    </>
                  )}
                  <div className="help-block">
                    {/* Fixing-bugs : validation for same subtypes */}
                    {data.error ? data.error : null}
                  </div>
                  {!data.editable &&
                  data.user_sub_type &&
                  index === userTypesData[item].length - 1 ? (
                    <i
                      title="Add User Sub Type"
                      className="fas fa-plus-circle "
                      onClick={() => this.addUserSubtype(data.user_type)}
                    ></i>
                  ) : null}
                </div>
              </Col>
              {this.state.dynamicHeader.map((header, b) => {
                const checkId = uuidv4();
                return (
                  <Col key={b}>
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={checkId}
                        name={header}
                        checked={data[header] === 1}
                        onChange={(e) =>
                          this.handleFieldsChange(e, data.permission_id, header)
                        }
                        disabled={
                          data.permission_id === 1 || data.permission_id === 2
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={checkId}
                      ></label>
                    </div>
                  </Col>
                );
              })}
            </Row>
          );
        });
      }
      return item;
    });
    return table;
  };

  showUserTypeModal = (edit, i) => {
    if (edit) {
      this.setState({
        showModal: !this.state.showModal,
        edit: true,
        index: i,
        error: "",
      });
    } else {
      this.setState({
        showModal: !this.state.showModal,
        error: "",
        newUserType: "",
      });
    }
  };

  handleExport = async () => {
    const bufferData = await this.props.export_usertypes();
    if (bufferData) {
      saveAs(
        new Blob([bufferData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `UserTypes.xls`
      );
    }
  };

  handleChange = (e) => {
    this.setState({
      newUserType: e.target.value,
    });
  };

  render() {
    const {
      userTypesData,
      headersData,
      newUserType,
      error,
      edit,
      rowAdded,
      loader,
    } = this.state;

    return (
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <Card.Title as="h4">Add/Edit User Types</Card.Title>
                  </div>
                  <div>
                    <Button
                      variant="info"
                      className="btn-fill btn-sm"
                      onClick={this.handleExport}
                      size="medium"
                    >
                      Export
                    </Button>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="pos-rel-overflow-hide">
                <div className="datatable-scroll">
                  <Row className="usertype-table-header">
                    <Col className="most-left-column"></Col>
                    <Col className="most-left-column"></Col>
                    {headersData.map((data, index) => {
                      return (
                        <>
                          <OverlayTrigger
                            delay={{ show: 250, hide: 400 }}
                            placement={"top"}
                            overlay={
                              <Tooltip id={`tooltip-qw`}>
                                {Object.values(data)[0]}
                              </Tooltip>
                            }
                          >
                            <Col className="usertypeHeader" key={index}>
                              {Object.values(data)[0]}
                            </Col>
                          </OverlayTrigger>
                        </>
                      );
                    })}
                  </Row>
                  {this.showUsersTypeTable(userTypesData)}
                </div>
              </Card.Body>
              <Col className="d-flex justify-content-between pb-3">
                {!rowAdded && (
                  <Button
                    className="btn-fill btn-sm"
                    type="button"
                    variant="info"
                    onClick={() => this.showUserTypeModal()}
                  >
                    Add User Type
                  </Button>
                )}
                <div className="">
                  {loader && <Spinner animation="border" variant="info" />}
                  {!loader && (
                    <Button
                      className="btn-fill btn-sm"
                      type="button"
                      variant="info"
                      onClick={this.handleSubmit}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </Col>
              <Row></Row>
            </Card>
          </Col>
        </Row>
        <Modal
          lg={"small"}
          show={this.state.showModal}
          backdrop={"static"}
          dialogClassName="modal-90w"
          fullscreen={"sm-down"}
        >
          <Card.Header className="d-flex justify-content-between bg-white align-items-center">
            <h4 className="m-0 font-weight-bold">
              <Card.Title className="m-0">
                {edit && "Edit "}
                {!edit && "Add "}
                User Type
              </Card.Title>
            </h4>
            <Button
              title={"Deactivate"}
              type="button"
              onClick={() => this.showUserTypeModal()}
              className="close-btn py-0"
              data-dismiss="modal"
            >
              <i className="nc-icon nc-simple-remove text-danger" />
            </Button>
          </Card.Header>
          <ModalBody>
            <label>
              User Type
              <span className="asterisk">*</span>
            </label>
            <Form.Control
              placeholder="User Type"
              type="text"
              name="usertype"
              value={newUserType}
              onChange={this.handleChange}
              autoComplete="off"
              required
            />
            <div className="help-block">{error.length ? error : null}</div>
          </ModalBody>
          <Modal.Footer>
            {edit && (
              <Button onClick={() => this.handleUserTypeName()}>Edit</Button>
            )}
            {!edit && <Button onClick={() => this.addUserType()}>Add</Button>}
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}
const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  Logindetails,
  SuperAdminDetails,
}) => {
  const { api_response, api_success_message, api_error_message } =
    APIResponseDetails;
  const { property } = UserProfileDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  const { allUserTypes } = SuperAdminDetails;
  return {
    UserProfileDetails,
    api_response,
    api_success_message,
    api_error_message,
    property,
    main_body,
    allUserTypes,
  };
};

const mapStateToDispatch = {
  get_all_user_types: SuperAdminAction.get_all_user_types,
  update_user_types: SuperAdminAction.update_user_types,
  export_usertypes: SuperAdminAction.export_usertypes,
};

export default connect(mapStateToProps, mapStateToDispatch)(UserTypes);
